<template>
  <div>
    <v-app>
      <!-- <v-alert :value="inDevelopmentMod" style="height: 20px; z-index: 9999; position: fixed; top: 0%;left: 45%;" type="warning">Development Mode</v-alert> -->
      <!--<v-progress-linear height="2" :indeterminate="true" v-if="!loadWorkplace && loggedIn"></v-progress-linear>-->
      <div id="app" style="background: #fcfcfc; height: 100%">
        <router-view></router-view>
      </div>
    </v-app>

    <!--Message dialog-->
    <v-dialog v-model="showMessageDialog" persistent max-width="400">
      <v-card class="pt-5">
        <v-card-text>{{messageDialogMessage}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="blue darken-1" flat @click="closeMessageDialog">Entendo</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Confirmation dialog-->
    <v-dialog v-model="showConfirmationDialog" persistent max-width="500">
      <v-card class="pt-5">
        <v-card-text v-html="confirmationDialogMessage"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" :loading="confirmationDialogLoading" text @click="confirmConfirmationDialog()">Sim</v-btn>
          <v-btn color="grey darken-1" v-if="!confirmationDialogLoading" text @click="cancelConfirmationDialog()">Não</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--Snackbar-->
    <v-snackbar
        v-model="snackbarVisible"
        bottom
        right
        :timeout=3000
        :color='snackbarColor'
    >
      <span v-html="snackbarText"></span>
      <v-btn color="white" flat @click="snackbarVisible = false"><v-icon small>clear</v-icon></v-btn>
    </v-snackbar>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import {eventBus} from "./main";
  import { Global } from './config';

  export default {
    name: 'App',

    mounted(){
      this.getLoggedUserInfos();

      eventBus.$on('onConfirmationDialogFinishLoading', () => {
        this.showConfirmationDialog = false;
        // EventBus.$off('onConfirmationDialogFinishLoading');
        setTimeout(()=>{
          this.consoleLog('DeleteLoadingFinish');
          this.confirmationDialogLoading = false;
        },300)
      });
    },

    data() {
      return {
        Global,
        confirmationDialogLoading: false,
      }
    },

    components:{
      // Login,
      // Workplace
    },

    methods: {
      cancelConfirmationDialog(){
        this.showConfirmationDialog = false;
      },
      confirmConfirmationDialog(){
        eventBus.$emit('onConfirmationDialog');
        this.confirmationLoading = true;
        // this.showConfirmationDialog = false;
      },

      getLoggedUserInfos() {
        this.$store.dispatch('loggedUserInfos').then(response => {
          if(!response.data.success){
            this.showSnackBar('Erro ao carregar as suas informações.', 'error');
          }
        }, error => {
          this.consoleLog(error);
        });
      },
      closeMessageDialog(){
        this.showMessageDialog = false;
        this.messageDialogMessage = '';
      }
    },

    computed:{
      ...mapGetters([
        'getToken',
        'loggedIn',
      ]),
      inDevelopmentMod(){
        // return true;
          return Global.APP_IN_DEVELOPMENT_MODE;
      },
      loadWorkplace:{
        get(){
          return this.$store.getters.loadWorkplace;
        },
        set(value){
          this.$store.dispatch('loadWorkplace', value);
        }
      },

      loggedUser:{
        get() {
          return this.$store.getters.loggedUser;
        },
        set(value){
          this.$store.dispatch('loggedUser', value);
        }
      },
      snackbarVisible: {
        get() {
          return this.$store.getters.getSnackbarVisible;
        },
        set(value) {
          this.$store.dispatch('setSnackbarVisible', value);
        }
      },
      snackbarText: {
        get() {
          return this.$store.getters.getSnackbarText;
        },
        set(value) {
          this.$store.dispatch('setSnackbarText', value);
        }
      },
      snackbarColor: {
        get() {
          return this.$store.getters.getSnackbarColor;
        },
        set(value) {
          this.$store.dispatch('setSnackbarColor', value);
        }
      },
      showMessageDialog: {
        get() {
          return this.$store.getters.getShowMessageDialog;
        },
        set(value) {
          this.$store.dispatch('setShowMessageDialog', value);
        }
      },
      messageDialogMessage: {
        get() {
          return this.$store.getters.getMessageDialogMessage;
        },
        set(value) {
          this.$store.dispatch('setMessageDialogMessage', value);
        }
      },
      confirmationDialogMessage: {
        get() {
          return this.$store.getters.getConfirmationDialogMessage;
        },
        set(value) {
          this.$store.dispatch('setConfirmationDialogMessage', value);
        }
      },
      showConfirmationDialog: {
        get() {
          return this.$store.getters.getShowConfirmationDialog;
        },
        set(value) {
          this.$store.dispatch('setShowConfirmationDialog', value);
        }
      },

      companyName(){
        try{
          return this.loggedUser.group.company.name;
        }catch (e) {
          return '';
        }
      }
    },

  }
</script>

<style>
  {
    text-transform: none !important;
  }
</style>
